import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import AdminApprovalBypass from 'garaje/components/account-settings/admin-approval-bypass';
import UiHeader from 'garaje/components/ui/header';
import UiPage from 'garaje/components/ui/page';
import type CompanyConfiguration from 'garaje/models/company-configuration';
import type { LocationOverviewVisitorsSettingsRouteModel } from 'garaje/pods/location-overview/visitors/settings/route';

interface LocationOverviewVisitorsSettingsSignature {
  Args: {
    model: LocationOverviewVisitorsSettingsRouteModel;
  };
}

export class LocationOverviewVisitorsSettingsTemplate extends Component<LocationOverviewVisitorsSettingsSignature> {
  // Undefined on first render: the route loads it without blocking its transition.
  get companyConfiguration(): CompanyConfiguration | undefined {
    return this.args.model?.loadCompanyConfigurationTask.lastSuccessful?.value ?? undefined;
  }

  // A load that settles without a record is not loading: the panel falls back to its default state.
  get isConfigLoading(): boolean {
    const task = this.args.model?.loadCompanyConfigurationTask;
    if (!task) return false;
    return !task.lastSuccessful && !task.lastErrored;
  }

  <template>
    <UiPage>
      <div class="w-full">
        <UiHeader>Visitors settings</UiHeader>
      </div>

      <AdminApprovalBypass @companyConfiguration={{this.companyConfiguration}} @isLoading={{this.isConfigLoading}} />
    </UiPage>
  </template>
}

export default RouteTemplate(LocationOverviewVisitorsSettingsTemplate);
